import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { TransactionResponseType } from "types/Transaction";
import url from "url/index";
import { setHostname } from "utils/hostname";
import { getAuthToken } from "helpers/authToken";
import { getLocalStorageItem } from "utils/localStorage";
import { APP_VERSION, STORAGE_AUTH_TOKEN } from "constants/variables";
import { getDepositTransaction, getWithdrawTransaction } from "./slice";

export const transactionsApi = createApi({
  reducerPath: "transactionsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: setHostname(),
    prepareHeaders: (headers) => {
      const authHeaders = getAuthToken();
      if (authHeaders) {
        Object.entries(authHeaders).forEach(([key, value]) => {
          headers.set(key, value as string);
        });
      }

      headers.set("f-v", APP_VERSION);

      return headers;
    },
  }),
  endpoints: (build) => ({
    deposit: build.query<TransactionResponseType, string>({
      query: (sort) => {
        const params: Record<string, any> = {
          type: "deposit",
          limit: 10,
          page: 1,
        };

        if (sort && parseInt(sort, 10)) {
          params.systemId = sort;
        }

        return {
          url: url.config.api.payments.transactions,
          params,
          headers: {
            Authorization: `Bearer ${getLocalStorageItem(STORAGE_AUTH_TOKEN)}`,
          },
        };
      },
      async onQueryStarted(string, { dispatch, queryFulfilled }) {
        try {
          const { data, meta } = await queryFulfilled;
          if (meta && meta.response && meta.response.status === 200) {
            const depositResponse = data.items.filter(
              (transaction) => transaction.type.toLowerCase() === "deposit",
            );
            dispatch(getDepositTransaction(depositResponse));
          }
        } catch (error: any) {
          // eslint-disable-next-line no-console
          console.error("Error executing the deposit request:", error);
        }
      },
    }),
    withdraw: build.query<TransactionResponseType, string>({
      query: (sort) => {
        const params: Record<string, any> = {
          type: "withdraw",
          limit: 25,
          page: 1,
        };

        if (sort && parseInt(sort, 10)) {
          params.systemId = sort;
        }

        return {
          url: url.config.api.payments.transactions,
          params,
          headers: {
            Authorization: `Bearer ${getLocalStorageItem(STORAGE_AUTH_TOKEN)}`,
          },
        };
      },
      async onQueryStarted(string, { dispatch, queryFulfilled }) {
        try {
          const { data, meta } = await queryFulfilled;
          if (meta && meta.response && meta.response.status === 200) {
            const withdrawResponse = data.items.filter(
              (transaction) => transaction.type.toLowerCase() === "withdraw",
            );
            dispatch(getWithdrawTransaction(withdrawResponse));
          }
        } catch (error: any) {
          // eslint-disable-next-line no-console
          console.error("Error executing the withdraw request:", error);
        }
      },
    }),
  }),
});
